import { dataMinus } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMinus = /*#__PURE__*/createIcon(dataMinus)
export default IconMinus
